module.exports = {
    title: "Karma Credit",
    crud: {
        create: "Create Karma Credit",
        edit: "Edit Karma Credit",
        tableTitle:"History",
    },
    table: {
        module: "Module",
        tasks: "Tasks",
        credits: "Credits",
        remarks: "Remarks",
        actions: "Actions",
        columns:{
            module:"module",
            tasks:"tasks",
            credits:"credits",
            remarks:"remarks",
            actions:"actions",
        }
    },
    form: {
        module: "Module",
        tasks: "Tasks",
        credits: "Credits",
        remarks: "Remarks"
    },
    validation: {
        required: {
            currentPercentage: 'Current percentage is required',
            currentApplyDate: 'Current apply date is required',
        }
    },
}
